import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './api/ApiError';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        // Never retry auth/validation/business errors — the response won't change.
        if (isApiError(error)) {
          if (
            error.kind === 'authentication' ||
            error.kind === 'authorization'  ||
            error.kind === 'validation'     ||
            error.kind === 'not_found'
          ) {
            return false;
          }
        }
        return failureCount < 2;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 30_000),
    },
    mutations: {
      retry: false,
    },
  },
});
